export { ProductMediaGallery } from './ProductMediaGallery';
